import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Material } from "../_types/material";

@Injectable({
    providedIn: 'root',
})

export class MaterialsService extends Service<Material> {
  public override type = 'materials';
  public override url = 'providers/materials';

}
